import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'resourceName' })
export class ResourceNamePipe implements PipeTransform {
  transform(item: any): string {
    return item.Name || item.VehicleCode;
  }
}
